var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cards-list',{attrs:{"items":_vm.items,"search":_vm.$route.query.q}})}
var staticRenderFns = []

export { render, staticRenderFns }